<template lang="pug">
section.faq
  .content
    h2.faq__title(data-animate="fade-translate") {{ $t("promo.faq.title") }}
    .faq__list(v-if="faq_content.length")
      FaqSpoilerItem(v-for="(item, index) in faq_content", :key="index")
        template(slot="faq-spoiler_title") {{ item.question }}
        div(v-html="item.answer")
</template>

<script>
import FaqSpoilerItem from "@static_promo_pages/common/components/faq/vue/FaqSpoilerItem.vue";
import axios from "axios";

export default {
  name: "Faq",

  components: {
    FaqSpoilerItem,
  },

  data() {
    return {
      request_url: "/api/faq/luckybox",
      faq_content: [],
    };
  },
  created() {
    document.addEventListener("init_vue_components", () => {
      this.getFaqInfo();
    });
  },
  methods: {
    getFaqInfo() {
      axios.get(this.request_url).then(response => {
        if (response.data.data) {
          this.faq_content = response.data.data;
        }
      });
    },
  },
};
</script>
